import { useContext, useEffect, useState } from "react";
import useStyles, { Card } from "../../styles";
import Grid from "@material-ui/core/Grid";
import { clsx } from 'modules/Utils';
import CircularStep from "../CircularStep";
import { Container, StyledLabelP } from 'modules/Sty';
import { SpendBudgetContext } from "Hooks/BudgetTabSpendContext/BudgetTabSpendContext";
import useBrand from 'Hooks/useBrand';
import { DEFAULT_CURRENCY, PRO_MONTHLY_PLAN_PRICE } from "modules/Const";
import getSymbolFromCurrency from "currency-symbol-map";
import { getConvertedCurrency_api } from "api/campaignApi";
import { getNumberWithDecimals } from "helpers/General";
import useScreen from "Hooks/useScreen";
import useUser from "Hooks/useUser";
import useCampaignBuilder from "Hooks/useCampaignBuilder";


const format = (budget: number, showDigits?: boolean) => {
  const numberOfDigits = showDigits ? 2 : 0

  return budget.toLocaleString("en-US", {
    minimumFractionDigits: numberOfDigits,
    maximumFractionDigits: numberOfDigits,
  })
}

const BudgetCard = () => {
  const { budget } = useCampaignBuilder();
  const classes = useStyles();
  const { mobileView } = useScreen()

  return (
    <Card borderRadius={mobileView ? undefined : "12px"}>
      <Grid container direction="column">
        <Grid item className={clsx(classes.space, classes.border)}>
          <Grid container alignItems="center" spacing={2}>
            <Grid item>
              <CircularStep step={1} />
            </Grid>
            <StyledLabelP fontSize={18} fontWeight={600}>
              Budget
            </StyledLabelP>
          </Grid>
        </Grid>
        <Container className={clsx(classes.space, classes.border)}
          display="flex" flexDirection="row"
          justifyContent="space-between">
          <Container width="75%" justifyContent="flex-start">
            <StyledLabelP fontSize={16} fontWeight={600}>
              Marketing Budget
            </StyledLabelP>
            <StyledLabelP color="#707070" fontSize={14} fontWeight={400}>
              This amount will be charged and spent on your YouTube Ads campaign.
            </StyledLabelP>
          </Container>
          <Container width="25%" display="flex" justifyContent="flex-end">
            <StyledLabelP fontSize={16} fontWeight={400}>
              {getSymbolFromCurrency(DEFAULT_CURRENCY)}
              {format(Number(budget), true)}
            </StyledLabelP>
          </Container>
        </Container>
      </Grid>
    </Card>
  );
};

export default BudgetCard;
